import { getToken } from './auth';

// Concurrent callers share one in-flight Cognito session lookup. Nothing is kept
// after it settles, so an expired token is never reused.
let inFlightToken = null;

function getAuthToken() {
  if (!inFlightToken) {
    inFlightToken = getToken().finally(() => {
      inFlightToken = null;
    });
  }
  return inFlightToken;
}

/**
 * fetch with the Authorization header attached. Options (method, body, signal,
 * extra headers) are passed straight through, so callers keep their own
 * response/error handling.
 */
export async function authorizedFetch(url, options = {}) {
  const token = await getAuthToken();
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
}
